const { __ } = wp.i18n;
/**
 * Container block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("WC tables", "uipress-pro"),
  moduleName: "uip-woocommerce-analytics-tables",
  description: __("Outputs your choice of order data from woocommerce as a table", "uipress-lite"),
  group: "storeanalytics",
  icon: "table_chart",
};
